import { AxiosResponseHeaders } from 'axios';
import { SwiftCountriesResponseDTO, SwiftCountry } from '../entities';

const swiftCountriesResponseDTOToSwiftCountriesResponseAdapter = (
  data: SwiftCountriesResponseDTO,
  headers?: AxiosResponseHeaders,
): SwiftCountry[] => {
  if (!data.body) {
    throw new Error('Error');
  }
  const swiftCountries = data.body.countries.map(
    (sc, index) => new SwiftCountry(index, sc.countryName, sc.countryName),
  );
  return swiftCountries;
};

export { swiftCountriesResponseDTOToSwiftCountriesResponseAdapter };
